// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"240":"2d847939","265":"4cf39f98","297":"c65c6b37","367":"39731b6d","643":"20bd019e","787":"c1d89ab5"}[chunkId] + ".chunk.js";
};